export default class ProductListViewMode {
    constructor() {
        this.init();
    }

    init() {
        $('.product-list-view-mode__item').on('click.ProductListViewMode', this.onViewModeClick.bind(this));
        this.setViewMode(BX.getCookie('catalogViewMode') || 'grid');
    }

    reinit() {
        $('.product-list-view-mode__item').off('clickProductListViewMode');
        this.init();
    }

    onViewModeClick (e) {
        e.preventDefault();
        this.setViewMode($(e.currentTarget).attr('data-value'));
    }

    /**
     * @param {string} mode
     * @param {bool} temporary Optional. Set mode without cookie
     */
    setViewMode(mode, temporary) {
        const $items = $('.product-list-view-mode__item');
        $items.removeClass('product-list-view-mode__item--selected');
        $items.filter('[data-value="' + mode + '"]').addClass('product-list-view-mode__item--selected');

        $('.product-list--catalog').toggleClass('product-list--table', mode == 'table');
        $('.product-list--catalog').toggleClass('product-list--grid', mode == 'grid');
        $('.model-list--catalog').toggleClass('model-list--table', mode == 'table');
        $('.model-list--catalog').toggleClass('model-list--grid', mode == 'grid');
        $('.product-list--catalog .product-list-item').toggleClass('product-list-item--table', mode == 'table');
        $('.product-list--catalog .product-list-item').toggleClass('product-list-item--grid', mode == 'grid');
        //$('.product-list-nav2').toggleClass('product-list-nav2--table', mode == 'table');

        if (temporary !== true) {
            BX.setCookie('catalogViewMode', mode, {path: '/', expires: 86400 * 30});
        }
    }
}